// Auto-import SASS generated CSS
import './index.css';

export type {DialogProps} from './Dialog';
export type {CustomDialogProps} from './CustomDialog';
export {default as CustomDialog} from './CustomDialog';
export {default as Dialog} from './Dialog';
export {default as default} from './Dialog';
